import { Database } from '@dolfin/business/db_types'
import { createBrowserClient } from '@supabase/ssr'

export function createClient() {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!
  const client = createBrowserClient<Database>(
    supabaseUrl,
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY!
  )

  // Version-sensitive workaround: SupabaseClient derives Realtime endpoints from
  // supabaseUrl, while only direct RealtimeClient construction supports a custom
  // endpoint. Review these properties whenever the Supabase packages are upgraded.
  if (supabaseUrl.includes('://localhost')) {
    client.realtime.endPoint = client.realtime.endPoint.replace(
      'localhost',
      '127.0.0.1'
    )
    client.realtime.httpEndpoint = client.realtime.httpEndpoint.replace(
      'localhost',
      '127.0.0.1'
    )
  }

  return client
}
